import {field} from 'mc';
import * as FormaUhrady from 'mc/lib/api/gen/proxioapi/FormaUhrady';
import {DateRangeField, Select} from 'mc/lib/field';
import {Filter} from 'mc/lib/filter';
import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import * as FormaUhradyInfo from '../../api/FormaUhradyInfo';
import * as ZdrojPlatby from "mc/lib/api/gen/proxioapi/ZdrojPlatby";
import * as ZdrojPlatbyInfo from '../../api/ZdrojPlatbyInfo';
import * as StavPlatby from '../../api/StavPlatby';
import EnumField from '../../field/EnumField';

export default class PlatbaFilter extends PureComponent {

    static propTypes = {
        values: PropTypes.object.isRequired,
        onChange: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.fields = [
            {
                name: 'stavPlatby',
                label: 'Platby',
                component: this.renderStavPlatby,
            },
            {
                name: 'cisloDokladu',
                label: 'Číslo dokladu',
                component: field.String,
            },
            {
                name: 'vs',
                label: 'VS',
                component: field.String,
            },
            {
                name: 'datumPlatby',
                label: 'Datum platby',
                component: DateRangeField,
            },
            {
                name: 'ss',
                label: 'SS',
                component: field.String,
            },
            {
                name: 'cisloUctu',
                label: "Číslo účtu plátce",
                component: field.String,
            },
            {
                name: 'poznamka',
                label: "Poznámka",
                component: field.String,
            },
            {
                name: 'formaUhrady',
                label: 'Forma úhrady',
                initialValue: null,
                component: this.renderFormaUhrady,
            },
            {
                name: 'zdroj',
                label: 'Zdroj',
                initialValue: null,
                component: this.renderZdroj,
            },
        ];
    }

    renderStavPlatby = props => {
        return <Select {...props}>
            {StavPlatby.values.map(value => (
                <option key={value} value={value}>{StavPlatby.getCaption(value)}</option>
            ))}
        </Select>;
    };

    renderFormaUhrady = props => {
        return <EnumField items={FormaUhrady.values}
                          itemRender={FormaUhradyInfo.getCaption}
                          {...props}/>;
    };

    renderZdroj = props => {
        return <EnumField items={ZdrojPlatby.values}
                          itemRender={ZdrojPlatbyInfo.getCaption}
                          {...props}/>;
    };

    render() {
        const {values, onChange} = this.props;
        return <Filter fields={this.fields}
                       values={values}
                       onChange={onChange}/>;
    }

}
